import React, { useState, useEffect, useContext } from 'react';
import { X, Plus, Trash2, Users } from 'lucide-react';
import api from '../utils/api';
import { AuthContext } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const SellerManagerModal = ({ isOpen, onClose, onRefreshSellers }) => {
    const { user } = useContext(AuthContext);
    const [sellers, setSellers] = useState([]);
    const [newSellerName, setNewSellerName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fetchSellers = async () => {
        try {
            const res = await api.get('/sellers');
            setSellers(res.data);
        } catch (error) {
            console.error('Satıcılar alınamadı:', error);
        }
    };

    useEffect(() => {
        if (isOpen && user?.role === 'admin') {
            fetchSellers();
        }
    }, [isOpen, user]);

    if (!isOpen || user?.role !== 'admin') return null;

    const handleAddSeller = async (e) => {
        e.preventDefault();
        if (!newSellerName.trim()) return;
        setIsSubmitting(true);

        try {
            await api.post('/sellers', { name: newSellerName.trim() });
            setNewSellerName('');
            fetchSellers();
            onRefreshSellers(); // Dropdown listesini de güncelle
        } catch (error) {
            toast.error(error.response?.data?.message || 'Satıcı eklenemedi.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Bu satıcıyı silmek istediğinize emin misiniz?')) {
            try {
                await api.delete(`/sellers/${id}`);
                fetchSellers();
                onRefreshSellers(); // Dropdown listesini de güncelle
            } catch (error) {
                toast.error('Silme işlemi başarısız.');
            }
        }
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm transition-all duration-300">
            <div className="bg-slate-800 border border-slate-700 w-full max-w-md rounded-2xl shadow-2xl flex flex-col max-h-[80vh] animate-slide-up">

                {/* Modal Header */}
                <div className="flex justify-between items-center p-6 border-b border-slate-700/50">
                    <h2 className="text-xl font-bold text-white flex items-center gap-2">
                        <Users className="text-primary-400" size={24} />
                        Kargo Satıcı Yönetimi
                    </h2>
                    <button onClick={onClose} className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-xl transition-colors">
                        <X size={20} />
                    </button>
                </div>

                {/* Modal Body */}
                <div className="p-6 overflow-y-auto custom-scrollbar">

                    {/* Satıcı Ekleme Formu */}
                    <form onSubmit={handleAddSeller} className="flex gap-2 mb-6">
                        <input
                            type="text"
                            placeholder="Yeni Satıcı (Firma) Adı..."
                            className="flex-1 px-4 py-3 bg-slate-900/50 border border-slate-700 rounded-xl text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
                            value={newSellerName}
                            onChange={(e) => setNewSellerName(e.target.value)}
                            required
                        />
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="flex items-center justify-center bg-primary-600 hover:bg-primary-500 text-white p-3 rounded-xl transition-colors shrink-0 disabled:opacity-50"
                        >
                            <Plus size={20} />
                        </button>
                    </form>

                    {/* Satıcı Listesi */}
                    <div className="space-y-2">
                        <h3 className="text-sm font-semibold text-slate-400 mb-3">Mevcut Satıcılar Listesi</h3>
                        {sellers.length > 0 ? (
                            sellers.map((seller) => (
                                <div key={seller.id} className="flex items-center justify-between p-3 bg-slate-900/30 border border-slate-700/50 rounded-xl group hover:bg-slate-700/30 transition-colors">
                                    <span className="text-slate-200 font-medium">{seller.name}</span>
                                    <button
                                        onClick={() => handleDelete(seller.id)}
                                        className="p-1.5 text-slate-500 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors opacity-0 group-hover:opacity-100"
                                        title="Satıcıyı Sil"
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                </div>
                            ))
                        ) : (
                            <div className="text-center p-4 bg-slate-900/30 rounded-xl text-slate-500 text-sm">
                                Henüz tanımlı hiçbir satıcı bulunamadı. Lütfen yukarıdan ekleyin.
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </div>
    );
};

export default SellerManagerModal;
